import React, { useState, useEffect } from 'react'
import WbButton from '../../components/common/WbButton'
//import WidgitPoint from '../../components/common/WidgitPoint'
import { Stack } from '@mui/material'
import WidgitPointToggle from '../common/WidgitPointToggle';



export default function WelcomeScreen({setSurveyStart, name, surveyData}) {
  const [widgitEnabled, setWidgitEnabled] = useState(() => {
    // Check for stored preference in cookie
    const cookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith('point_enabled='));
    
    // If cookie exists, use it
    if (cookieValue) {
      return cookieValue.split('=')[1] === 'true';
    }
    
    // If no cookie, check if should be auto-enabled
    const isGrade4OrBelow = surveyData?.participant?.yearGrade <= 4;
    const isSurveyWidgitEnabled = surveyData?.survey?.isWidgitEnabled;
    return isGrade4OrBelow || isSurveyWidgitEnabled || false;
  });

  const handleWidgitToggle = (newState) => {
    setWidgitEnabled(newState);
  };

  // Auto-enable Widgit based on conditions
  useEffect(() => {
    const isGrade4OrBelow = surveyData?.participant?.yearGrade <= 4;
    const isSurveyWidgitEnabled = surveyData?.survey?.isWidgitEnabled;
    
    if (isGrade4OrBelow || isSurveyWidgitEnabled) {
      handleWidgitToggle(true);
    }
  }, [surveyData]);

  // Hide toggle if auto-enabled for young students
  const shouldShowToggle = !(surveyData?.participant?.yearGrade <= 4);

  return (
    <div className="welcome point_sym_hover">
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <h1 className="point_sym_hover">{name}</h1>
      </Stack>
      <div className="point_sym_hover">
        <h2>Welcome to the survey</h2>
        <p>Please answer the questions as honestly as possible.</p>
      </div>
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
        <WbButton
          onClick={() => {
            setSurveyStart(true)
          }}
          CustomButtonText={'Start Survey'}
        ></WbButton>
        {shouldShowToggle && (
          <WidgitPointToggle
            onToggle={handleWidgitToggle}
            initialState={widgitEnabled}
          />
        )}
      </Stack>
    </div>
  )
}
